import React from "react"
import { Box, Container, Grid, Stack, Typography } from "@mui/material"
import useTrans from "@/hooks/useTrans"
import LendingLogo from "./LendingLogo"
import { getLinkExplorerAddress } from "@/components/dashboard/commons"
import { BlockchainNetwork } from "@renec-foundation/relend-adapter"
import Button from "@/components/base/Button"
import RelIcon from "@/assets/icons/rel.png"
import Image from "next/image"

const InfoItem = ({ title, subTitle }: { title: string; subTitle: string }) => {
  return (
    <Stack alignItems='center' gap={{ sm: 2, xs: 1 }}>
      <Typography className='text-primary font-montserrat text-2xl sm:text-5xl font-bold text-center'>
        {title}
      </Typography>
      <Typography className='text-neutral-600 text-xs sm:text-base text-center'>{subTitle}</Typography>
    </Stack>
  )
}

const HarnessThePower = () => {
  const trans = useTrans()

  return (
    <Box className='w-full bg-[#FBFCFA] py-10 sm:py-20'>
      <Container maxWidth='xl'>
        <LendingLogo />

        <Stack alignItems='center' gap={1}>
          <Typography className='text-neutral-1000 text-center font-montserrat text-2xl w-3/4 sm:w-full sm:text-[2.5rem] font-bold sm:leading-tight'>
            {trans.home.snapshot_of_our_success}
          </Typography>
          <Typography className='text-sm sm:text-base text-neutral-600 text-center sm:max-w-3xl w-3/4 sm:w-full'>
            {trans.home.explore_analytics}
          </Typography>
        </Stack>

        <Grid container className='mt-10'>
          <Grid item xs={4} sm={4} className='border-r sm:border-none border-solid border-secondary'>
            <InfoItem title='$4,2M+' subTitle={trans.home.total_supply} />
          </Grid>
          <Grid item xs={4} sm={4} className='border-r sm:border-none border-solid border-secondary'>
            <InfoItem title='$1.1M+' subTitle={trans.home.total_borrow} />
          </Grid>
          <Grid item xs={4} sm={4}>
            <InfoItem title='5,000+' subTitle={trans.home.unique} />
          </Grid>
        </Grid>

        <Stack alignItems='center' gap={1}>
          <Typography
            className='text-sm sm:text-xl text-neutral-1000 font-bold text-center mt-10 flex flex-col sm:flex-row items-center gap-1'
            component='a'
            href={getLinkExplorerAddress(BlockchainNetwork.SOLANA, "9HvM3nS2eDKWxNvi8vSFXRhHA1xhDW33rt4ZA1bE1DbV")}
            target='_blank'
          >
            <span className='flex items-center gap-1'>
              <Image src={RelIcon} alt='rel-icon' width={24} /> token:
            </span>
            <span className='underline italic text-[#2F80ED]'>9HvM3nS2eDKWxNvi8vSFXRhHA1xhDW33rt4ZA1bE1DbV</span>
          </Typography>
          <Button
            variant='primary'
            size='xl'
            className='!px-10'
            component='a'
            href='https://jup.ag/swap/USDT-9HvM3nS2eDKWxNvi8vSFXRhHA1xhDW33rt4ZA1bE1DbV'
            target='_blank'
          >
            Buy REL
          </Button>
        </Stack>
      </Container>
    </Box>
  )
}

export default HarnessThePower
